document.addEventListener("DOMContentLoaded", function () {
    // Element qu'on veut afficher à la première visite.
    const animated_element = document.querySelector('.wp-block-loader-home');
    const body_element = document.querySelector('body');

    // Enregistrement du fait que la personne visite le site pour la première fois ou non.
    if (!sessionStorage.getItem('firstVisit')) {
        sessionStorage.setItem('firstVisit', '1');
    } else {
        sessionStorage.setItem('firstVisit', '0');
    }

    if (sessionStorage.getItem('firstVisit') === '1') {
        // Ajout de la classe 'show-animation' à l'élément si première visite sur le site.
        // Remplacer par autre chose si besoin.
        animated_element.classList.add('show-animation');
        body_element.classList.add('show-animation');
    }
});

/* Ticket #10834 - Utiliser un titre de niveau 2 simulé avec ARIA (exemple : <p role=“heading” aria-level=“2”>) sur ces titres de section (Explore - Offices - Social) */
// Select the span element within the .menu__footer--middle .menu-item element
const spanElement = document.querySelector('.menu__footer--middle .menu-item span');

// Add the desired HTML tags before and after the span element
spanElement.innerHTML = '<p role="heading" aria-level="2">' + spanElement.innerHTML + '</p>';


(function ($) {
    "use strict";

    $(document).ready(function () {

        var mobileIndicator = false;
        // On teste si on est sur mobile ou pas (cf styles.css + footer.php)
        if ($('#mobile-indicator').is(':visible')) {
            mobileIndicator = true;
        } else {
            mobileIndicator = false;
        }
        // On teste aussi lors de tout resize et on rechargge la page en cas de changement de media query
        $(window).resize(function () {
            if ($('#mobile-indicator').is(':visible')) {
                if (mobileIndicator == false) {
                    mobileIndicator = true;
                    location.reload(); // On recharge la page si la media query a changé			
                }
            } else {
                if (mobileIndicator == true) {
                    mobileIndicator = false;
                    location.reload(); // On recharge la page si la media query a changé			
                }
            }
        });

        //console.log( 'scripts.js' ) ;
        // — — — — — — — — — — — — — — — — — — — — — — — — — — — —

        if (mobileIndicator == false) {
            //DESKTOP

            //Sticky header
            if ($('.header__sticky').length > 0) {
                var lastScrollTop = 0;
                var header = 108;
                $(window).scroll(function () {
                    var scrollPos = $(this).scrollTop();
                    if (scrollPos > header) {
                        $('.header__sticky').addClass('is-sticky');
                        $('.is-before-menu').addClass('is-sticky-menu');
                        lastScrollTop = scrollPos;
                    } else if (scrollPos == 0) {
                        $('.header__sticky').removeClass('is-sticky');
                        $('.is-before-menu').removeClass('is-sticky-menu');
                    }
                });
            }

        } else {
            //MOBILE
        }

        //MOBILE ET DESKTOP

        //Scroll to top
        if ($('.wp-block-back-to-top').length > 0) {
            var back_to_top = $('.wp-block-back-to-top');
            back_to_top.on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, 300);
            });
        }

        //Home animation
        if ($('.wp-block-loader-home.show-animation').length > 0) {
            setTimeout(function () {
                $('.wp-block-loader-home.show-animation').fadeTo('slow', 0.5, function () {
                    $('.wp-block-loader-home').css('display', 'none');
                    $('.wp-block-animation__logo').css('z-index', 'unset');
                    $('.is-before-menu').css('z-index', '1');
                    $('body').css('overflow-y', 'auto');
                });
            }, 3000);
        }

        //Main menu
        if ($('.menu-item-has-children').length > 0) {
            $('.menu-item-has-children .level1-span').on('click', function (event) {
                event.preventDefault();
                if ($('.menu-item-has-children .level1-span').hasClass('active')) {
                    $('.menu-item-has-children .level1-span').removeClass('active');
                    $('.menu-item-has-children .level1-span').attr('aria-expanded', 'false');
                    $('.menu-item-has-children .level2-ul').css('display', 'none');
                } else {
                    $(this).addClass('active');
                    $(this).attr('aria-expanded', 'true');
                    $(this).parent('.has-level2').find('.level2-ul').slideToggle();
                }
            });
        }

        //Close submenu
        if ($('.menu__close').length > 0) {
            $('.menu__close').on('click', function (event) {
                event.preventDefault();
                $(this).parents('.menu-item-has-children').find('.sub-menu').slideToggle();
                $(this).parents('.menu-item-has-children').find('.level1-span').removeClass('active');
                $(this).parents('.menu-item-has-children').find('.level1-span').attr('aria-expanded', 'false');
                $(this).parents('.menu-item-has-children').find('.level1-span').focus();
            });
        }

        //Responsive menu
        if ($('.hamberger-menu').length > 0) {
            $('.burger').on('click', function (event) {
                event.preventDefault();
                if ($('.veganburger').hasClass('active')) {
                    $('.veganburger').removeClass('active');
                    $('.veganburger').attr('aria-expanded', 'false');
                    $('.header__sticky').css('display', 'none');
                } else {
                    $('.veganburger').addClass('active');
                    $('.veganburger').attr('aria-expanded', 'true');
                    $('.header__sticky').css('display', 'block');
                }
            });
        }

        //Testimonies
        if ($('.wp-block-testimonies__button').length > 0) {
            $('.wp-block-testimonies__button').on('click', function (event) {
                event.preventDefault();
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).attr('aria-expanded', 'false');
                    $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__content').attr('aria-hidden', 'true');
                } else {
                    $(this).addClass('active');
                    $(this).attr('aria-expanded', 'true');
                    $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__content').attr('aria-hidden', 'false');
                }
                $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__content').slideToggle();
            });
        }

        //Close testimonies
        if ($('.wp-block-testimonies__close').length > 0) {
            $('.wp-block-testimonies__close').on('click', function (event) {
                event.preventDefault();
                $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__button').attr('aria-expanded', 'false');
                $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__button').removeClass('active');
                $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__content').attr('aria-hidden', 'true');
                $(this).parents('.wp-block-testimonies__item').find('.wp-block-testimonies__content').css('display', 'none');
            });
        }

        //Add text for external links
        $('.wysiwyg p > a[target="_blank"], .wysiwyg p > strong > a[target="_blank"], .wysiwyg li > a[target="_blank"], .wysiwyg li > strong > a[target="_blank"]').append('<span class="screen-reader-text"> (open a new tab)</span>');

        //Filter
        if ($('.wp-block-filter__title').length > 0) {
            $('.wp-block-filter__title:not(.is-style-not-allowed)').on('click', function (event) {
                event.preventDefault();
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).attr('aria-expanded', 'false');
                    $(this).parents('.wp-block-filter__select').find('.wp-block-filter__content').attr('aria-hidden', 'true');
                } else {
                    $(this).addClass('active');
                    $(this).attr('aria-expanded', 'true');
                    $(this).parents('.wp-block-filter__select').find('.wp-block-filter__content').attr('aria-hidden', 'false');
                }
                $(this).parents('.wp-block-filter__select').find('.wp-block-filter__content').slideToggle();
            });
        }

        //Close filter
        if ($('.wp-block-filter__close').length > 0) {
            $('.wp-block-filter__close').on('click', function (event) {
                event.preventDefault();
                $(this).parents('.wp-block-filter__select').find('.wp-block-filter__title').attr('aria-expanded', 'false');
                $(this).parents('.wp-block-filter__select').find('.wp-block-filter__title').removeClass('active');
                $(this).parents('.wp-block-filter__select').find('.wp-block-filter__content').attr('aria-hidden', 'true');
                $(this).parents('.wp-block-filter__select').find('.wp-block-filter__content').css('display', 'none');
            });
        }

    });

})(jQuery);